import { render, staticRenderFns } from "./DayCard.vue?vue&type=template&id=b527efa6&scoped=true&"
import script from "./DayCard.vue?vue&type=script&lang=js&"
export * from "./DayCard.vue?vue&type=script&lang=js&"
import style0 from "./DayCard.vue?vue&type=style&index=0&id=b527efa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b527efa6",
  null
  
)

export default component.exports